import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from "@mui/material/Tooltip";
/**
 * Renders an additional span around the children to make sure the tooltip works for disabled buttons.
 * @param props
 * @returns
 */
export function TooltipAlways(props) {
    const { title, children } = props;
    return (_jsx(Tooltip, { title: title, children: _jsx("span", { children: children }) }));
}
//# sourceMappingURL=TooltipAlways.js.map